import React, { Component } from "react";
import GridDataView from "@my-dld/components/DataView/GridDataView";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import Strings from "@my-dld/assets/strings";
import { EjariPropertyType } from "@eres/ejari-api/Entity";
import { showOnMap } from "@my-dld/utils/Utils";
import { ProjectPropertyProps } from "./ProjectPropertiesListView";
import {
	getProjectPropertyArea,
	getProjectPropertyBuilding,
	getProjectPropertyBuildingCount,
	getProjectPropertyType
} from "../../screens/Leased/ProjectProperties";

class ProjectPropertiesGridView extends Component<ProjectPropertyProps> {
	constructor( props: ProjectPropertyProps ) {
		super( props );
		this.state = {};
	}

	render() {
		const { properties, onPropertySelect } = this.props;
		return <GridDataView
			items={ properties }
			renderGridItem={ ( item: ProjectProperty, index: number ) => {
				return <RenderGridItem
					key={ "project_buildings_grid_" + index }
					property={ item }
					onDetails={ onPropertySelect }/>;
			} }/>;
	}
}

export function RenderGridItem( props: { property: ProjectProperty, onDetails: ( project: ProjectProperty ) => void } ) {
	const { property, onDetails } = props;
	const isBuilding = ( property.PropertyTypeId === EjariPropertyType.BUILDING );
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getProjectPropertyBuilding( property ) }</span>
							<span>{ isBuilding ? Strings.building_name : Strings.villa_name }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-12">
							<span>{ getProjectPropertyArea( property ) }</span>
							<span>{ Strings.area }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						{ isBuilding && <div className="col-12">
							<span>{ getProjectPropertyBuildingCount( property ) }</span>
							<span>{ Strings.no_of_properties }</span>
						</div> }
						{ !isBuilding && <div className="col-12">
							<span>{ getProjectPropertyType( property ) }</span>
							<span>{ Strings.no_of_bed_rooms }</span>
						</div> }
					</div>
					<div className="row no-gutters property-card-action">
						<div className="col-md-12">
							{ property.Latitude && property.Longitude &&
								<button
									className="btn-link"
									onClick={ () => showOnMap( property.Latitude!, property.Longitude! ) }>
									{ Strings.locate_on_map }</button> }
							<button
								className="btn-link"
								onClick={ () => onDetails( property ) }>
								{ isBuilding ? Strings.view_units : Strings.view_details }
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default ProjectPropertiesGridView;
